export const USER_ROLE = {
  USER: "user",
  ADMIN: "admin",
  SUB_ADMIN: "sub_admin",
  SUB_USER: "subuser",
};
